// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import animated from 'animate.css'
import WOW from 'wowjs'
import './assets/iconfont/iconfont.css'
import VueTouch from 'vue-touchjs';
import "./styles/swiper.min.css";
import store from './store/store'
import "./styles/cover.css";
import axios from "axios";
import VueParticles from 'vue-particles'  
Vue.use(VueParticles)  


Vue.use(animated)
Vue.use(WOW)
Vue.prototype.$wow=WOW
Vue.use(ElementUI)
Vue.use(VueTouch);
Vue.prototype.$axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({

  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js